<template>
  <div class="item-tax-controls">
    <div v-if="item.usar_imposto_manual" class="item-tax-manual-display">
      <label>Imposto</label>
      <span>Imposto manual</span>
    </div>

    <div
      :class="[
        'item-tax-actions',
        { 'item-tax-actions-ref': !item.usar_imposto_manual },
      ]"
    >
      <button
        v-if="item.usar_imposto_manual"
        type="button"
        class="item-tax-action item-tax-edit"
        aria-label="Editar imposto manual"
        v-b-tooltip.hover.top="'Editar imposto manual'"
        @click="$bvModal.show(modalId)"
      >
        <b-icon-pencil-square scale="1.3" />
      </button>

      <button
        type="button"
        class="item-tax-action"
        :aria-label="toggleModeLabel"
        v-b-tooltip.hover.top="toggleModeLabel"
        @click="toggleMode"
      >
        <b-icon-arrow-left-right scale="1.3" />
      </button>
    </div>

    <b-modal
      :id="modalId"
      size="xl"
      title="Imposto manual do item"
      @show="prepareDraft"
    >
      <ManualTax
        item-mode
        :imposto-manual="draft"
        :flags="manualFlags"
        @update:impostoManual="draft = $event"
        @updateFlags="manualFlags = $event"
      />

      <template #modal-footer>
        <b-button
          variant="secondary"
          style="height: 31px; font-size: 0.875rem"
          @click="$bvModal.hide(modalId)"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          style="height: 31px; font-size: 0.875rem"
          @click="saveDraft"
        >
          Salvar imposto do item
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ManualTax from "./ManualTax.vue";
import {
  cloneTaxData,
  completeManualTaxDefaults,
  createManualTax,
} from "../../utils/itemTax";

export default {
  components: { ManualTax },
  props: {
    item: {
      type: Object,
      required: true,
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      draft: createManualTax(),
      manualFlags: {
        enableCreditoPresumido: false,
        enableIssqn: false,
      },
    };
  },
  computed: {
    toggleModeLabel() {
      return this.item.usar_imposto_manual
        ? "Usar imposto da REF"
        : "Usar imposto manual";
    },
  },
  methods: {
    toggleMode() {
      this.$set(
        this.item,
        "usar_imposto_manual",
        !this.item.usar_imposto_manual
      );
    },
    prepareDraft() {
      this.draft = completeManualTaxDefaults(this.item.imposto_manual);

      this.manualFlags = {
        enableCreditoPresumido: Boolean(
          this.draft.icms?.informar_credito_presumido
        ),
        enableIssqn: Boolean(this.draft.issqn?.informar_issqn),
      };
    },
    saveDraft() {
      this.$set(
        this.draft.icms,
        "informar_credito_presumido",
        this.manualFlags.enableCreditoPresumido
      );
      this.$set(
        this.draft.issqn,
        "informar_issqn",
        this.manualFlags.enableIssqn
      );
      this.$set(this.item, "imposto_manual", cloneTaxData(this.draft));
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.item-tax-controls {
  position: absolute;
  inset: 0;
  z-index: 11;
  height: 30px;
  pointer-events: none;
}

.item-tax-manual-display {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 47px 0 11px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  color: #495057;
  font-family: Poppins-Regular, sans-serif;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: auto;
}

.item-tax-manual-display label {
  position: absolute;
  top: -6px;
  left: 4px;
  z-index: 2;
  margin: 0;
  padding: 0 3px;
  background: #fff;
  color: #666360;
  font-size: 9px;
  font-weight: 600;
  line-height: 12px;
}

.item-tax-manual-display span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-tax-actions {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: flex;
  height: 100%;
  pointer-events: auto;
}

.item-tax-actions-ref {
  right: 0;
}

.item-tax-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 100%;
  padding: 0;
  border: 1px solid #dedede;
  border-left: none;
  border-radius: 0 3px 3px 0;
  background: #fff;
  color: #006256;
  cursor: pointer;
  font-size: 10px;
  transition: background-color 0.2s, border-color 0.2s;
}

.item-tax-edit {
  border-color: #006256;
  border-radius: 3px 0 0 3px;
  background: #006256;
  color: #fff;
}

.item-tax-edit + .item-tax-action {
  border-left: 0;
  border-radius: 0 3px 3px 0;
}

.item-tax-action:hover,
.item-tax-action:focus {
  border-color: #006256;
  background: #edf7f5;
  outline: none;
}

.item-tax-edit:hover,
.item-tax-edit:focus {
  border-color: #004f45;
  background: #004f45;
  color: #fff;
}
</style>
